// extracted by mini-css-extract-plugin
module.exports = {"form_preview_section_wrapper":"FormPreviewSectionWrapper_form_preview_section_wrapper__2_Ni3","wider":"FormPreviewSectionWrapper_wider__2nZ1s"};